import React, { useCallback } from "react";
import TableProgressModal from "src/modules/table-progress/table-progress-modal/table-progress-modal";
import { useAppDispatch, useAppSelector } from "../../../../stores/redux/hooks";
import { getAppModel, getIsTableProgressModalOpen } from "../helpers/selectors";
import { setIsTableProgressModalOpenAction } from "../../../../stores/redux/features/flowdesigner/flowdesigner.slice";

const TableProgressFD = () => {
    const dispatch = useAppDispatch();

    const appModel = useAppSelector(getAppModel);
    const isTableProgressVisible = useAppSelector(getIsTableProgressModalOpen);

    const setTableProgressVisible = useCallback(
        (value: boolean) => dispatch(setIsTableProgressModalOpenAction(value)),
        [dispatch]
    );

    if (!appModel || !isTableProgressVisible) return;
    return (
        <>
            <TableProgressModal
                appModel={appModel}
                isTableProgressVisible={isTableProgressVisible}
                setTableProgressVisible={setTableProgressVisible}
            />
        </>
    );
};

export default TableProgressFD;
